/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const DownChevronIcon: React.FC = (): JSX.Element => (
  <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.33305 1.33374L3.99972 4.66707L0.666382 1.33374" fill="#8795A1" />
    <path
      d="M7.33305 1.33374L3.99972 4.66707L0.666382 1.33374H7.33305Z"
      stroke="#8795A1"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
